<div class="container-idle">
    <div class="modal" tabindex="-1">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <div>
                        <h4 class="mb-0">
                            Datos de facturación
                        </h4>
                        <h4>
                        <small
                            class="text-muted"
                            *ngIf="vendor">

                            {{ vendor.nit }} - {{ vendor.name }}

                        </small>
                        </h4>
                    </div>
                    <button
                        type="button"
                        class="btn-close"
                        (click)="closeModal()">
                    </button>
                </div>

                <div class="modal-body">
                    <app-loading-animation
                        *ngIf="loading"
                        [height]="'10rem'">
                    </app-loading-animation>
                    <ng-container *ngIf="!loading">
                        <!-- <div class="card mb-4">
                            <div class="card-body">
                                <h5 class="mb-3">
                                    Porcentaje
                                </h5>
                                <div class="row">
                                    <div class="col-md-4">
                                        <label for="percentage" class="form-label">
                                            Porcentaje
                                        </label>
                                        <div class="input-group">
                                            <input
                                                type="number"
                                                id="percentage"
                                                name="percentage"
                                                class="form-control"
                                                [(ngModel)]="percentage"
                                                min="0"
                                                max="100"
                                                step="0.01">
                                            <span class="input-group-text">
                                                %
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div> -->
                        <div class="card">
                            <div class="card-body">
                                <h5 class="mb-3">
                                    NIT de facturación
                                </h5>
                                <div class="row align-items-end">
                                    <div class="col-md-4 form-group">
                                        <label for="billingNitInput" class="form-label">
                                            NIT
                                        </label>
                                        <input
                                            type="text"
                                            id="billingNitInput"
                                            name="billingNitInput"
                                            class="form-control"
                                            placeholder="Ingresa el NIT"
                                            [(ngModel)]="billingNitInput"
                                            (blur)="checkNIT()"
                                            (keyup.enter)="checkNIT()">
                                    </div>
                                    <div class="col-md-5 form-group">
                                        <label for="billingNameInput" class="form-label">
                                            Nombre
                                        </label>
                                        <input
                                            type="text"
                                            id="billingNameInput"
                                            name="billingNameInput"
                                            class="form-control"
                                            placeholder="Ingresa el nombre"
                                            [(ngModel)]="billingNameInput">
                                    </div>
                                    <div class="col-md-3">
                                        <button
                                            type="button"
                                            class="btn btn-primary w-100"
                                            [disabled]="
                                                !billingNitInput ||
                                                !billingNameInput
                                            "
                                            (click)="addBillingData()">

                                            <i class="fa fa-plus"></i>
                                            Agregar
                                        </button>
                                    </div>
                                </div>

                                <div class="billing-table-container mt-4">
                                    <table
                                        class="table table-hover table-striped table-sm mb-0">
                                        <thead>
                                            <tr>
                                                <th>
                                                    NIT
                                                </th>
                                                <th>
                                                    Nombre
                                                </th>
                                                <th
                                                    class="text-center action-column">
                                                    Acción
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr *ngFor="let billing of billingNits; let i = index ">
                                                <td>
                                                    {{ billing.billingNit }}
                                                </td>
                                                <td>
                                                    {{ billing.billingName }}
                                                </td>
                                                <td class="text-center">
                                                    <button
                                                        type="button"
                                                        class="btn btn-sm btn-outline-danger"
                                                        title="Eliminar"
                                                        (click)="
                                                            deleteBillingData(i)
                                                        ">
                                                        <i
                                                            class="
                                                                fa
                                                                fa-trash
                                                            ">
                                                        </i>
                                                    </button>
                                                </td>
                                            </tr>
                                            <tr *ngIf="billingNits.length === 0">
                                                <td
                                                    colspan="3"
                                                    class="text-center text-muted py-4">
                                                    <i
                                                        class=" fa fa-circle-info ">
                                                    </i>
                                                    No se tienen NIT de
                                                    facturación agregados
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </ng-container>
                </div>

                <div class="modal-footer">
                    <button
                        type="button"
                        class="btn btn-secondary"
                        [disabled]="saving"
                        (click)="closeModal()">
                        CANCELAR
                    </button>
                    <button
                        type="button"
                        class="btn btn-success"
                        [disabled]="saving || loading"
                        (click)="save()">
                        <ng-container *ngIf="!saving">
                            <i class="fa fa-floppy-disk"></i>
                        </ng-container>
                        <ng-container *ngIf="saving">
                            <span class=" spinner-border spinner-border-sm me-1">
                            </span>
                        </ng-container>
                        {{ saving ? 'GUARDANDO...' : 'GUARDAR' }}
                    </button>
                </div>
            </div>
        </div>
    </div>
</div>